import React from "react";
import styleClasses from "./career.module.scss";
import * as CONSTANT from "../../constants";
import { Col, Row } from "react-bootstrap";
import { REACT_APP_CLOUD_FRONT } from "../../constants";

export interface TeamJobs {
  image: any;
  title: string;
  content: string;
  href: string;
}

const teamJobsArray: TeamJobs[] = [
  {
    image: 'images/career-overview/hospitality.png',
    title: "Hospitality",
    content: "Interact & serve",
    href: "/hospitality-team",
  },
  {
    image: 'images/career-overview/culinary.png',
    title: "culinary",
    content: "Work With Real Food",
    href: "/culinary-team",
  },
  {
    image: 'images/career-overview/leadership.png',
    title: "leadership",
    content: "Lead Restaurants & People",
    href: "/leadership-team",
  },
  {
    image: 'images/career-overview/catering.png',
    title: "catering",
    content: "cater any & all events",
    href: "/catering-team",
  },
];

const TeamJobs = () => {
  return (
    <div className={`${styleClasses.teamJobs}`}>
      <div className={styleClasses.customeRow}>
        <Row>
          {teamJobsArray.map((item, i) => {
            return (
              <Col sm={6} md={6} lg={3} className="mb-5" key={i}>
                <div className={styleClasses.customeCol}>
                  <a href={item.href}>
                    <img
                      src={`${REACT_APP_CLOUD_FRONT}/${item.image}`}
                      className={`img-fluid ${styleClasses.imgss}`}
                      alt={item.title}
                    />
                    <h2
                      className={`f-s30 f-w7 clr-dark-grey font-Trade-bold text-capitalize pt-3 f-sm-s24  ${styleClasses.heading}`}>
                      {item.title}
                    </h2>
                    <p
                      className={`${styleClasses.desc} f-s20 f-w4 clr-dark-grey font-Trade-regular mb-0 f-sm-s16 text-capitalize`}>
                      {item.content}
                    </p>
                  </a>
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
      <div className="text-center">
          <a
            href={CONSTANT.CAREERS_APPLY_ROUTE_URL}
            target="blank"
            className={`text-decoration-none color-white f-w7 font-Visby-cf text-uppercase f-sm-s14 btn btn-large mt-0 mt-md-4 ${styleClasses.careerBtns}`}>
            view all jobs
          </a>
      </div>
    </div>
  );
};

export default TeamJobs;
